var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCancelSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0701 4.93002C16.5593 2.33046 12.8413 1.2879 9.34501 2.20305C5.84872 3.1182 3.11827 5.84865 2.20311 9.34495C1.28796 12.8412 2.33052 16.5593 4.93008 19.07C7.44083 21.6696 11.1589 22.7121 14.6552 21.797C18.1515 20.8818 20.8819 18.1514 21.7971 14.6551C22.7122 11.1588 21.6696 7.44077 19.0701 4.93002Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7099 8.29C15.5222 8.10069 15.2666 7.9942 14.9999 7.9942C14.7333 7.9942 14.4777 8.10069 14.2899 8.29L11.9999 10.59L9.70994 8.29C9.31782 7.89788 8.68206 7.89788 8.28994 8.29C7.89782 8.68212 7.89782 9.31788 8.28994 9.71L10.5899 12L8.28994 14.29C8.10063 14.4778 7.99414 14.7334 7.99414 15C7.99414 15.2666 8.10063 15.5222 8.28994 15.71C8.47771 15.8993 8.7333 16.0058 8.99994 16.0058C9.26658 16.0058 9.52217 15.8993 9.70994 15.71L11.9999 13.41L14.2899 15.71C14.4777 15.8993 14.7333 16.0058 14.9999 16.0058C15.2666 16.0058 15.5222 15.8993 15.7099 15.71C15.8993 15.5222 16.0057 15.2666 16.0057 15C16.0057 14.7334 15.8993 14.4778 15.7099 14.29L13.4099 12L15.7099 9.71C15.8993 9.52223 16.0057 9.26664 16.0057 9C16.0057 8.73336 15.8993 8.47777 15.7099 8.29Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSolid);
export default ForwardRef;